/**
 * 技术总结更新请求体
 */
export interface TechEssentialUpdateApiRequest {
    /**
     * 任务ID
     */
    task_id: string;
    /**
     * 技术总结
     */
    text: string;
}

export type TechEssentialUpdateApiResponse = void;

/**
 * 技术总结更新API
 */
export interface TechEssentialUpdateApi {
    /**
     * 更新技术总结
     * @param data 技术总结更新请求体
     * @returns 技术总结更新响应体
     */
    updateTechSummary(data: TechEssentialUpdateApiRequest): Promise<TechEssentialUpdateApiResponse>;
}

export const TechEssentialUpdateApi = Symbol.for('TechEssentialUpdateApi');
